import { createFileRoute, redirect } from '@tanstack/react-router'
import { AppBootScreen } from '@/components/layout/AppBootScreen'
import { AppShell } from '@/components/layout/AppShell'
import { CommandPalette } from '@/components/command/CommandPalette'
import {
  DeferredNotFound,
  DeferredRouteError,
} from '@/components/layout/deferredRouteChrome'
import { useGlobalHotkeys } from '@/hooks/useHotkeys'
import { bootstrapAuth } from '@/lib/apiClient'
import { consumeLoginOpensHome } from '@/lib/lastVisited'

/**
 * 3-section layout: rail + Vision AI (chat) + Network Operations (dashboard)
 */
export const Route = createFileRoute('/_app')({
  pendingComponent: AppBootScreen,
  pendingMs: 0,
  pendingMinMs: 0,
  beforeLoad: async ({ location }) => {
    const authed = await bootstrapAuth()
    if (!authed) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
        replace: true,
      })
    }
    // Sign in always opens home — do not keep `/chat/$id` from the last session.
    if (consumeLoginOpensHome() && location.pathname !== '/') {
      throw redirect({ to: '/', replace: true })
    }
  },
  component: NewAppLayout,
  notFoundComponent: DeferredNotFound,
  errorComponent: DeferredRouteError,
})

function NewAppLayout() {
  useGlobalHotkeys()
  return (
    <>
      <AppShell />
      <CommandPalette />
    </>
  )
}
